import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import api from "../../services/api";
import { workspaceSlug } from "../../config";
export default function SubscriptionNotice({user}) {
 const [status,setStatus]=useState(null);
 useEffect(()=>{
  if(user?.profile!=="admin" || !workspaceSlug()){setStatus(null);return;}
  let alive=true;
  const check=()=>api.get("/subscription/status").then(r=>{if(alive)setStatus(r.data)}).catch(()=>{});
  check();const timer=setInterval(check,60000);
  const onVisible=()=>{if(!document.hidden)check()};document.addEventListener("visibilitychange",onVisible);
  return()=>{alive=false;clearInterval(timer);document.removeEventListener("visibilitychange",onVisible)};
 },[user?.id,user?.profile]);
 if(!status?.renewalNotice)return null;
 return <Box role="alert" style={{flexShrink:0,background:"#fff3cd",color:"#533f03",padding:"10px 16px",display:"flex",gap:10,alignItems:"center",flexWrap:"wrap",borderBottom:"1px solid #ead89c"}}><WarningIcon aria-hidden="true"/><Typography variant="body2" style={{flex:1,minWidth:160}}>Seu período de acesso vence em {new Date(status.expiresAt).toLocaleString("pt-BR",{timeZone:"America/Sao_Paulo",dateStyle:"short",timeStyle:"short"})}. Renove sua assinatura para continuar usando o ZapTicket.</Typography><Button variant="outlined" size="small" href="/assinatura" style={{color:"inherit",borderColor:"currentColor"}}>Renovar assinatura</Button></Box>;
}
